import { Link } from "react-router";

const footerSections = [
	{
		title: "Produkt",
		links: [
			{ label: "Služby", href: "/#funkce" },
			{ label: "Firemní události", href: "/firemni-udalosti" },
			{ label: "Ceník", href: "/cenik" },
			{ label: "API dokumentace", href: "https://api.firmindex.cz/reference", external: true },
		],
	},
	{
		title: "Procházet",
		links: [
			{ label: "Vyhledávání firem", href: "/search" },
			{ label: "Odvětví (NACE)", href: "/directory/odvetvi" },
			{ label: "Kraje", href: "/directory/kraj" },
		],
	},
	{
		title: "Společnost",
		links: [
			{ label: "O nás", href: "/o-nas" },
			{ label: "Kontakt", href: "/kontakt" },
		],
	},
	{
		title: "Právní",
		links: [
			{ label: "Obchodní podmínky", href: "/podminky" },
			{ label: "Ochrana soukromí", href: "/ochrana-soukromi" },
			{ label: "Zásady cookies", href: "/cookie-policy" },
		],
	},
];

export function Footer() {
	return (
		<footer className="px-3 pb-3 pt-10 text-muted sm:px-4">
			<div className="glass-panel-strong mx-auto max-w-7xl rounded-3xl px-6 py-12 lg:px-8">
				<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
					{footerSections.map((section) => (
						<div key={section.title}>
							<h3 className="text-sm font-semibold text-text">{section.title}</h3>
							<ul className="mt-4 flex flex-col gap-3">
								{section.links.map((link) => (
									<li key={link.label}>
										{"external" in link && link.external ? (
											<a
												href={link.href}
												target="_blank"
												rel="noopener noreferrer"
												className="text-sm transition-colors hover:text-primary"
											>
												{link.label}
											</a>
										) : (
											<Link to={link.href} className="text-sm transition-colors hover:text-primary">
												{link.label}
											</Link>
										)}
									</li>
								))}
							</ul>
						</div>
					))}

					{/* Contact column */}
					<div>
						<h3 className="text-sm font-semibold text-text">Kontakt</h3>
						<ul className="mt-4 flex flex-col gap-3 text-sm">
							<li>Recadev s.r.o.</li>
							<li>info@firmindex.cz</li>
							<li>IČO: 07654090</li>
							<li>Ostrava, Česká republika</li>
						</ul>
					</div>
				</div>

				<div className="mt-12 border-t border-white/70 pt-8 text-center text-sm text-muted">
					&copy; {new Date().getFullYear()} Recadev s.r.o. Všechna práva vyhrazena.
				</div>
			</div>
		</footer>
	);
}
